// src/components/PrivateRoute.jsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = () => {
  const { usuario, loading: authLoading, loadingUserDoc } = useAuth();
  const location = useLocation();

  // Rotas que devem ser acessíveis mesmo com cadastro incompleto
  const rotasPermitidasComCadastroIncompleto = [
    '/finalizar-cadastro',
    '/assinatura-pendente',
    // Adicione outras rotas que o usuário deve acessar, mesmo com cadastro incompleto (se houver)
  ];

  console.log('PrivateRoute: Render:');
  console.log('  usuario:', usuario);
  console.log('  authLoading:', authLoading);
  console.log('  loadingUserDoc:', loadingUserDoc);
  console.log('  pathname:', location.pathname);

  // 1. Enquanto a autenticação ou o documento do usuário estão carregando,
  // exiba um indicador de carregamento.
  if (authLoading || loadingUserDoc) {
    console.log('PrivateRoute: Ainda carregando dados essenciais...');
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-lg text-gray-700">Carregando...</p>{' '}
        {/* Ou um spinner */}
      </div>
    );
  }

  // 2. Se não há usuário logado, redirecione para a página de login.
  // Note: O PrivateRoute só é usado em rotas protegidas no seu router.jsx,
  // então se o usuário não existe aqui, ele deve ir para o login.
  if (!usuario) {
    console.log('PrivateRoute: Usuário não logado. Redirecionando para login.');
    return <Navigate to="/login" replace />;
  }

  // 3. Se o usuário está logado, mas o cadastro não está completo
  // E a rota ATUAL não está na lista de rotas permitidas para cadastro incompleto,
  // redirecione para a página de finalizar cadastro.
  if (
    usuario.cadastroCompleto === false &&
    !rotasPermitidasComCadastroIncompleto.includes(location.pathname)
  ) {
    console.log(
      'PrivateRoute: Cadastro incompleto. Redirecionando para /finalizar-cadastro'
    );
    return <Navigate to="/finalizar-cadastro" replace />;
  }

  // 4. Se todas as verificações passaram, o usuário pode acessar a rota.
  console.log('PrivateRoute: Usuário autorizado. Renderizando Outlet.');
  return <Outlet />;
};

export default PrivateRoute;
